import * as yup from "yup";

export interface Report {
	description: string;
	name: string;
	productId: string;
	reportId: string;
	url: string;
	lastUpdatedDate: string;
	lastUpdatedBy: string;
	createdBy: string;
	createdDate: string;
}

export interface ReportEditRequest {
	description: string;
	name: string;
	productId: string;
	url: string;
	reportId: string;
}

export const ReportEditRequestValidationSchema = yup.object().shape({
	name: yup.string().required().label("Name"),
	url: yup.string().required().url().label("URL"),
	description: yup.string().label("Description").nullable(),
});
